import { render, staticRenderFns } from "./BankReport.vue?vue&type=template&id=0395c031&"
import script from "./BankReport.vue?vue&type=script&lang=js&"
export * from "./BankReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports